import React from 'react';
//import { Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faMapMarkerAlt, faBars } from '@fortawesome/free-solid-svg-icons';

import { history } from "../_core/history";

import logo from '../_img/korg.svg';
//global component
import Topbar from './Topbar';
import MainNav from './MainNav';
//services
import { postService } from '../_services/post.service';
// import { productService } from '../_services/product.service';
//styles
import './MainMenu.sass';

import MessengerCustomerChat from "react-messenger-customer-chat";

class MainMenu extends React.Component {
  constructor(props) {
    super(props);

    var getSearchedProduct;

    if(window.location.pathname === '/products/'){
      getSearchedProduct = window.location.search ? window.location.search.replace('?kw=','').replace('%20',' ') : '';
    }

    this.state = {
      search: getSearchedProduct ? getSearchedProduct : '',
      address: '',
      phone: {},
      storeAddress: null,
    };

    this.searchItem = this.searchItem.bind(this)
  }

  componentDidMount() {
      postService.getSettingsWoo().then(settingAdd => this.setState({address:settingAdd}))

      //postService.getBySlug('nav-phone').then(phone => this.setState({phone}))

  }


  handleSearch = (e) => {
    e.preventDefault();
    const search = e.target.value
    this.setState({
      search: search.replace(/\s+/g, " ").replace(/^\s+/, "")
    },()=>{
      if(e.which === 13 || e.keyCode === 13 || e.key === 'Enter'){
        this.searchItem()
      }
    })
  }

  searchItem = (e) => {
    const { search } = this.state;
    if (!search || search === " ") {
      e.preventDefault()
    } else {
      e.preventDefault()
      history.push({
        pathname: '/products/',
        search: '?kw=' + search
      })
      window.location.reload();
    }
  }


  render() {
    //const user = this.props.user;
    const { search, address, phone } = this.state;
    const menu = this.props.menu;
    const topbarMenu = this.props.topbarMenu;

    return (
        <>
      <header>
        {/* <MessengerCustomerChat
          pageId={process.env.REACT_APP_FB_PAGE_ID}
          appId={process.env.REACT_APP_FB_APP_ID}
          themeColor="#FFA162"
        />
        <Topbar menu={topbarMenu} navPhone={phone}/>
        <div className="navbar-sticky">
          <div className="navbar navbar-expand-lg py-3">
            <div className="container">
              <a href="/" className="navbar-brand d-none d-sm-block mr-3 flex-shrink-0">
                <img src={logo} alt="Korg" style={{ width: "120px", height: "42px" }} />
              </a>
              <a className="navbar-brand d-sm-none mr-2" href="/">
                <img src={logo} alt="Korgs" style={{ width: "74px" }} />
              </a>
              <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#MainMenu">
                <span className="navbar-toggler-icon pt-2"> <FontAwesomeIcon icon={faBars} /></span>
              </button>
              <form onSubmit={(e) => this.searchItem(e)} className="input-group-overlay d-none d-lg-flex mx-4">
                <input className="form-control appended-form-control form-control-lg" type="text" placeholder="Search" value={search} onChange={(e) => this.handleSearch(e)} />
                <div className="input-group-append-overlay">
                  <span className="input-group-text">
                    <Nav.Link href="#!" className="search-icon" onClick={(e) => this.searchItem(e)}>
                      <FontAwesomeIcon icon={faSearch} />
                    </Nav.Link>
                  </span>
                </div>
              </form>
              <div className="navbar-text  d-none d-lg-block">
                <p className="float-left mr-3 mb-0"><FontAwesomeIcon icon={faMapMarkerAlt} /> </p>
                <p className="mb-0  address small" style={{ fontSize: "12.8px", color: "#5A5E60", fontWeight: "400", lineHeight: "19.2px" }} >
                  {address}
                </p>
              </div>
            </div>
          </div>
          
          <div className="main-nav navbar navbar-expand-lg p-0" style={{ zIndex: 11 }}>
            <div className="container-fluid">
              <div className="navbar-collapse collapse justify-content-md-center" id="MainMenu">
                
                <div className="input-group-overlay d-lg-none my-3">
                  <div className="input-group-prepend-overlay">
                    <span className="input-group-text">
                      <FontAwesomeIcon icon={faSearch} aria-hidden="true" />
                    </span>
                  </div>
                  <input className="form-control prepended-form-control" type="text" placeholder="Search" value={search} onChange={(e) => this.handleSearch(e)} />
                </div>
                <MainNav menu={menu} />
              </div>
            </div>
          </div>
        </div> */}
        <MessengerCustomerChat
          pageId={process.env.REACT_APP_FB_PAGE_ID}
          appId={process.env.REACT_APP_FB_APP_ID}
          themeColor="#FFA162"
        />
        <Topbar menu={topbarMenu} navPhone={phone} />
        {/* logo, search box, address, main navigation */}
        <div className="navbar-sticky">
          {/* Begin: Korg logo, search bar, address */}
          <div className="container p-0">
            <div className="navbar navbar-expand-lg p-0 pt-3 py-md-3">
              {/* logo */}
              <a href="/" className="navbar-brand d-none d-sm-block mr-3 flex-shrink-0">
                <img src={logo} alt="Korg" width="120" />
              </a>
              {/* logo responsive */}
              <a className="navbar-brand d-sm-none m-0 p-0 mr-2 ml-3" href="/">
                <img src={logo} alt="Korg" width="74" />
              </a>
              {/* search bar */}
              <form className="form-inline flex-fill mr-3" onSubmit={(e) => this.searchItem(e)}>
                <div className="input-group-overlay d-flex ml-4">
                  <input
                    className="form-control appended-form-control form-control-lg w-100"
                    type="text"
                    placeholder="Search"
                    value={search}
                    onChange={(e) => this.handleSearch(e)}
                  />
                  <div className="input-group-append-overlay" onClick={(e) => this.searchItem(e)}>
                    <span className="input-group-text"><FontAwesomeIcon icon={faSearch} /></span>
                  </div>
                </div>								
              </form>
              {/* address */}
              <div style={{ width: 255 }} className="navbar-text d-none d-lg-block flex-shrink-0 ml-4">
                <p className="float-left mr-3 mb-0"><FontAwesomeIcon icon={faMapMarkerAlt} /></p>
                <p className="mb-0 address small" style={{ fontSize: "12.8px", color: "#5A5E60", fontWeight: "400", lineHeight: "19.2px" }}>{address}</p>
              </div>
            </div>
          </div>
          {/* End: Korg logo, search bar, address */}
        </div>
      </header>
      <div className="sticky-top">
          <div className="container p-0">
            <div className="navbar-expand-lg">
                {/* responsive menu button trigger */}
                <button className="navbar-toggler btn-block m-0 mt-3 bg-dark rounded-0" type="button" data-toggle="collapse" data-target="#MainMenu">
                  <p className="m-2 text-light text-left float-left">MENU</p> 
                  <span className="navbar-toggler-icon pt-1 float-right text-light"><FontAwesomeIcon icon={faBars} /></span>
                </button>
            </div>
          </div>
          {/* Begin: Main Navigation */}
          <div className="main-nav navbar navbar-expand-lg p-0">
            <div className="container-fluid">
              <div className="navbar-collapse collapse justify-content-md-center" id="MainMenu">
                <MainNav menu={menu} />	
              </div>
            </div>
          </div>
          {/* End: Main Navigation */}
        </div>
      </>
    )
  }
}

export default MainMenu;